export default "__VITE_ASSET__CsGR0JEl__"